export const MAX_DECIMAL_SYMBOLS = 2;
